/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';
import SimpleSticky from 'app/components/commons/SimpleSticky';
import FriendsLoader from 'app/components/friends/common/FriendsLoader';
import t from 'app/utils/translate';
import Performance from './Performance';
import TeamPerformanceHead from './TeamPerformanceHead';
import UserStats from './UserStats';

type Props = {
  commonPlayerIds: Array<string>,
  commonTeamIds: Array<string>,
  comparison: Array<*>,
  diffValue?: boolean,
  displayPlayersCount?: boolean,
  displayWidget?: boolean,
  entryCount: number,
  hasProjections: boolean,
  isLoading?: boolean,
  isModal?: boolean,
  isRacing?: boolean,
  isSticky?: boolean,
  myAvatar?: Object,
  myEntry?: Object,
  onComparisonReset: () => void,
  onPerformanceDiffChange: () => void,
  onStatusSelect: () => void,
  opponentEntry?: Object,
  statusFilters: Object
};

const Wrapper = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  [theme.mediaQuery.desktopAndUp]: {
    maxHeight: '100vh'
  }
}));

const Main = styled.div(({ theme }) => ({
  backgroundColor: theme.color.white,
  flexGrow: 1,
  minHeight: 100,
  overflowX: 'hidden',
  position: 'relative'
}));

const StatsOuter = styled.div({
  display: 'flex',
  flexBasis: 'auto',
  flexGrow: 0,
  flexShrink: 0
});

class TeamPerformanceTable extends React.PureComponent<Props> {
  props: Props;

  static defaultProps = {
    diffValue: false,
    displayPlayersCount: false,
    displayWidget: false,
    isLoading: false,
    isModal: false,
    isRacing: false,
    isSticky: false,
    myAvatar: undefined,
    myEntry: {},
    opponentEntry: {}
  };

  render() {
    const {
      commonPlayerIds,
      commonTeamIds,
      comparison,
      diffValue,
      displayPlayersCount,
      displayWidget,
      entryCount,
      hasProjections,
      isLoading,
      isModal,
      isRacing,
      isSticky,
      myAvatar,
      myEntry,
      onComparisonReset,
      onPerformanceDiffChange,
      onStatusSelect,
      opponentEntry,
      statusFilters
    } = this.props;

    return (
      <SimpleSticky isStuckFunc={isStuck => isStuck && isSticky} offsetTop={80}>
        <Wrapper>
          <TeamPerformanceHead
            diffValue={diffValue}
            displayOpponent={!!opponentEntry.id}
            displayUser={!!myEntry.id}
            onComparisonReset={onComparisonReset}
            onDisplayChange={onPerformanceDiffChange}
            showCloseButton={!!opponentEntry.id || isModal}
          />
          <StatsOuter>
            {myEntry.id && (
              <UserStats
                key={myEntry.id}
                avatar={myAvatar}
                compact={!!opponentEntry.id}
                displayPlayersCount={displayPlayersCount}
                entryCount={entryCount}
                isUltimateChampion={myEntry.isUltimateChampion}
                name={myEntry.userName}
                onStatusSelect={onStatusSelect}
                playersCount={myEntry.playersCount}
                prize={myEntry.prize}
                rank={myEntry.rank}
                score={myEntry.score}
                scoreProjected={myEntry.scoreProjected}
                showProjected={hasProjections && !opponentEntry.id}
                statusFilters={statusFilters}
                highlight
              />
            )}
            {opponentEntry.id && (
              <UserStats
                key={opponentEntry.id}
                avatar={opponentEntry.avatar}
                compact={!!myEntry.id}
                displayPlayersCount={displayPlayersCount}
                entryCount={entryCount}
                isUltimateChampion={opponentEntry.isUltimateChampion}
                name={opponentEntry.userName}
                onStatusSelect={onStatusSelect}
                playersCount={opponentEntry.playersCount}
                prize={opponentEntry.prize}
                rank={opponentEntry.rank}
                score={opponentEntry.score}
                scoreProjected={opponentEntry.scoreProjected}
                statusFilters={statusFilters}
                showProjected={hasProjections && !myEntry.id}
              />
            )}
          </StatsOuter>
          <Main>
            {isLoading && (
              <FriendsLoader showOverlay>
                {t('Loading line up')}
                ...
              </FriendsLoader>
            )}
            <Performance
              commonPlayerIds={commonPlayerIds}
              commonTeamIds={commonTeamIds}
              diffValue={diffValue}
              displayOpponent={!!opponentEntry.id}
              displayUser={!!myEntry.id}
              displayWidget={displayWidget}
              isModal={isModal}
              isRacing={isRacing}
              items={comparison}
              compact={!!opponentEntry.id && !!myEntry.id}
            />
          </Main>
        </Wrapper>
      </SimpleSticky>
    );
  }
}

export default TeamPerformanceTable;
